"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[53120],{

/***/ 4881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);

function useScrollChat() {
    var highlightChat = function(id) {
        var bubbleElement = document.getElementById("".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_BUBBLE_ID */ .H2, "-").concat(id));
        bubbleElement.classList.add("chat-highlight");
        setTimeout(function() {
            bubbleElement.classList.remove("chat-highlight");
        }, 3000);
    };
    var scrollToBottom = function() {
        setTimeout(function() {
            var contentElement = document.getElementById(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_CONTENT_CONTAINER_ID */ .mR);
            if (contentElement) {
                contentElement.scrollTo({
                    top: contentElement.scrollHeight,
                    behavior: "smooth"
                });
            }
        }, 50);
    };
    var scrollToChatBubble = function(id) {
        var bubbleId = "".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_BUBBLE_ID */ .H2, "-").concat(id);
        var contentElement = document.getElementById(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_CONTENT_CONTAINER_ID */ .mR);
        var bubbleElement = document.getElementById(bubbleId);
        if (bubbleElement) {
            contentElement.scrollTo({
                top: bubbleElement.offsetTop - contentElement.offsetTop - bubbleElement.offsetHeight * 0.1,
                behavior: "smooth"
            });
            highlightChat(id);
        } else {
            contentElement.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            setTimeout(function() {
                scrollToChatBubble(id);
            }, 500);
        }
    };
    return {
        scrollToBottom: scrollToBottom,
        scrollToChatBubble: scrollToChatBubble,
        highlightChat: highlightChat
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useScrollChat);


/***/ }),

/***/ 37220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useGetReferralInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_api_community__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89561);
/* harmony import */ var stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7639);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);





var useGetReferralInfo = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return {
        isLoading: false,
        fetchCommunityInfo: function fetchCommunityInfo() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var remisierUI, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            remisierUI = stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().getUIValue("remisier");
                            if (!remisierUI) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            // If remisier UI is not exists, then we fetch from API
                            set({
                                isLoading: true
                            });
                            _ctx.next = 7;
                            return (0,lib_api_community__WEBPACK_IMPORTED_MODULE_1__/* .getReferralInfo */ .Qu)();
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error("failed to get community info");
                        case 10:
                            data = response.data.data;
                            stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().setUIValue("remisier", {
                                isLeader: data.is_leader,
                                isCommunityAccessGranted: data.enabled || data.is_leader
                            });
                            set({
                                isLoading: false
                            });
                            _ctx.next = 19;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            set({
                                isLoading: false
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }))();
        }
    };
});


/***/ }),

/***/ 60602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IX": function() { return /* binding */ AVATAR_SIZE; },
/* harmony export */   "Rm": function() { return /* binding */ ONBOARDING_MAX_STEP; },
/* harmony export */   "Wo": function() { return /* binding */ ONBOARDING_REQUEST_FILTER; }
/* harmony export */ });
var ONBOARDING_MAX_STEP = 4;
var AVATAR_SIZE = {
    BIG: "BIG",
    SMALL: "SMALL",
    PORTRAIT: "PORTRAIT"
};
// DISCOVER PEOPLE
var ONBOARDING_USER_SUGGEST_LIMIT = 30;
var ONBOARDING_USER_SUGGEST_PAGE = 1;
var ONBOARDING_USER_SUGGEST_FILTER = "FILTER_ONBOARDING";
var ONBOARDING_REQUEST_FILTER = {
    limit: ONBOARDING_USER_SUGGEST_LIMIT,
    page: ONBOARDING_USER_SUGGEST_PAGE,
    filter: ONBOARDING_USER_SUGGEST_FILTER
};



/***/ }),

/***/ 53120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/features/onboarding/constants.ts
var constants = __webpack_require__(60602);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
;// CONCATENATED MODULE: ./src/hooks/useOnBoarding.ts




function useOnBoarding() {
    var ref = (0,react.useState)(Infinity), onboardingProgress = ref[0], setOnboardingProgress = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref1.data;
    var progress = dataProfile.onboarding, statusOnboarding = dataProfile.onboarding_done;
    (0,react.useEffect)(function() {
        // redirect only if data profile is available
        if (dataProfile.id && statusOnboarding == 0 && progress <= constants/* ONBOARDING_MAX_STEP */.Rm) {
            setOnboardingProgress(progress);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        progress,
        statusOnboarding,
        dataProfile
    ]);
    return {
        onboardingProgress: onboardingProgress
    };
}
/* harmony default export */ var hooks_useOnBoarding = (useOnBoarding);

// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/hooks/useProfileData.ts
var useProfileData = __webpack_require__(30995);
// EXTERNAL MODULE: ./src/hooks/useNotificationListener.ts
var useNotificationListener = __webpack_require__(91364);
// EXTERNAL MODULE: ./src/features/edit-profile/slice.ts
var slice = __webpack_require__(40927);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/global/Notification/index.tsx + 1 modules
var Notification = __webpack_require__(77667);
// EXTERNAL MODULE: ./src/features/chat/MainContent/useScrollChat.ts
var useScrollChat = __webpack_require__(4881);
// EXTERNAL MODULE: ./src/features/chat/store/index.ts + 7 modules
var store = __webpack_require__(77284);
// EXTERNAL MODULE: ./src/global/WebSocketV2/slice.ts + 1 modules
var WebSocketV2_slice = __webpack_require__(66250);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var chat_slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/stores/chat/index.ts + 2 modules
var chat = __webpack_require__(50490);
// EXTERNAL MODULE: ./src/features/chat/utils.ts
var utils = __webpack_require__(33037);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
;// CONCATENATED MODULE: ./src/utils/socketSocial.ts



var transformToNotifMessage = function(rawText, type) {
    var text = sanitize_html_default()(rawText);
    var _obj;
    var attachmentContentMapper = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_PHOTO */.G0.ATTACHMENT_TYPE_PHOTO, " *IMAGE*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_GIF */.G0.ATTACHMENT_TYPE_GIF, " *GIF*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_POST */.G0.ATTACHMENT_TYPE_POST, " *POST*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_STICKER */.G0.ATTACHMENT_TYPE_STICKER, " *STICKER*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_PDF */.G0.ATTACHMENT_TYPE_PDF, ""), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED, ""), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_SHARETRADE */.G0.ATTACHMENT_TYPE_SHARETRADE, ""), _obj);
    text += attachmentContentMapper[type];
    return text;
};


;// CONCATENATED MODULE: ./src/hooks/useChatListenerWsSocialV2.ts
/* eslint-disable eqeqeq */ /* eslint-disable no-undef */ 



















var checkMessageDuplicated = function(messages, newRoomId, lastMessageId) {
    if (messages[newRoomId]) {
        var ref;
        return (ref = messages[newRoomId]) === null || ref === void 0 ? void 0 : ref.messages.some(function(chat) {
            return chat.id === lastMessageId;
        });
    }
    return false;
};
var checkMissingObjectText = function(body) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var chatMessageV1 = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatMessage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.message;
    var valueText = (chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref4 = chatMessageV1.body) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.conversation) === null || ref5 === void 0 ? void 0 : ref5.text) ? chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref6 = chatMessageV1.body) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.conversation) === null || ref7 === void 0 ? void 0 : ref7.text : "";
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1), {
        text: valueText,
        body: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1.body), {
            conversation: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref8 = chatMessageV1.body) === null || ref8 === void 0 ? void 0 : ref8.conversation), {
                text: valueText,
                attachmentType: (chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref9 = chatMessageV1.body) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.conversation) === null || ref10 === void 0 ? void 0 : ref10.attachmentType) || constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED
            })
        })
    });
};
var handleRefreshGroupRoom = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatId) {
        var hasRoomDetail, ref, groupId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return store/* roomDetailStore.getState */.e.getState().refreshGroupRoomDetail(chatId);
                case 2:
                    hasRoomDetail = _ctx.sent;
                    if (!hasRoomDetail) {
                        _ctx.next = 9;
                        break;
                    }
                    ;
                    groupId = (ref = store/* roomDetailStore.getState */.e.getState().group[chatId]) === null || ref === void 0 ? void 0 : ref.id;
                    _ctx.next = 8;
                    return store/* groupMemberStore.getState */.VY.getState().fetchGroupMember(groupId, 0);
                case 8:
                    chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                        state.conversation.isLoading = false;
                    }));
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleRefreshGroupRoom(chatId) {
        return _ref.apply(this, arguments);
    };
}();
function useChatListenerWsSocialV2() {
    var isUserLogin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var dispatch = (0,es/* useDispatch */.I0)();
    var activeRoomId = (0,es/* useSelector */.v9)(chat_slice/* selectors */.wl).activeRoomId;
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), _notifications = ref.notifications, notif = _notifications.data;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataLoggedInUser = ref1.data;
    var newIncomingChatWsSocialV2 = (0,es/* useSelector */.v9)(WebSocketV2_slice/* chatWsSocialV2Selector */.WM);
    var messages = (0,chat/* default */.Z)(function(store) {
        return store.conversation.messages;
    });
    var defaultRooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.default.list;
    });
    var invitedRooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.invited.list;
    });
    var updateRoomListFromWS = (0,chat/* default */.Z)(function(store) {
        return store.updateRoomListFromWS;
    });
    var pushMessage = (0,chat/* default */.Z)(function(store) {
        return store.pushMessage;
    });
    var updateMessageFromWS = (0,chat/* default */.Z)(function(store) {
        return store.updateMessageFromWS;
    });
    var scrollToBottom = (0,useScrollChat/* default */.Z)().scrollToBottom;
    var actionChatRoom = function(incomingChat) {
        if (activeRoomId > 0) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            var body = incomingChat.body;
            var newMessage = checkMissingObjectText(body);
            var newRoom = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatMessage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.room;
            var referenceId = body === null || body === void 0 ? void 0 : (ref4 = body.event) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.chatMessage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref7 === void 0 ? void 0 : ref7.referenceId;
            var roomStatus = body === null || body === void 0 ? void 0 : (ref8 = body.event) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.chatMessage) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref11 === void 0 ? void 0 : ref11.roomStatus;
            newMessage = (0,utils/* snakelizeKeys */.t_)(newMessage);
            newRoom = (0,utils/* snakelizeKeys */.t_)(newRoom);
            var isDuplicated = messages ? checkMessageDuplicated(messages, newRoom === null || newRoom === void 0 ? void 0 : newRoom.id, newMessage === null || newMessage === void 0 ? void 0 : newMessage.id) : false;
            // Check if the event comes when user leave
            var isStateUnspecified = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.state) === constant/* StateChatList.ROOM_STATE_UNSPECIFIED */.Kn.ROOM_STATE_UNSPECIFIED;
            var isDeletedEvent = (newMessage === null || newMessage === void 0 ? void 0 : (ref12 = newMessage.body) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.conversation) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.flag) === null || ref14 === void 0 ? void 0 : ref14.is_deleted) ? newMessage === null || newMessage === void 0 ? void 0 : (ref15 = newMessage.body) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.conversation) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.flag) === null || ref17 === void 0 ? void 0 : ref17.is_deleted : false;
            if (!isDuplicated && !isStateUnspecified && !isDeletedEvent) {
                var ref18, ref19, ref20, ref21, ref22;
                var chatId = newRoom.id;
                // push message to state;
                pushMessage({
                    chatId: chatId,
                    message: newMessage,
                    reference_id: referenceId,
                    room_status: roomStatus,
                    room: newRoom
                });
                // scroll to bottom if in current active chat is receive new message
                var isChatPageShowed = router_default().asPath.includes("/chat/".concat(chatId)) || router_default().asPath.includes("/group-chat/".concat(chatId)) || router_default().asPath.includes("/broadcast-chat/".concat(chatId));
                var senderUserData = newMessage === null || newMessage === void 0 ? void 0 : (ref18 = newMessage.body) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.conversation) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.sender) === null || ref20 === void 0 ? void 0 : ref20.user;
                var senderUserName = senderUserData && senderUserData.username ? senderUserData.username : "";
                var isReceiver = senderUserName !== dataLoggedInUser.username;
                if (isChatPageShowed) {
                    var container = document.getElementById("chat-content-container");
                    var currentPos = container.scrollHeight - container.clientHeight - 200;
                    var currentlyScrollingUp = container.scrollTop < currentPos;
                    // when there is incoming message on receiver side, that is currently scrolling up
                    // don't scroll to bottom
                    if (isReceiver && !currentlyScrollingUp || !isReceiver) {
                        scrollToBottom();
                    }
                }
                // Handle event type message from ws in group chat
                // will refresh the room detail and member list
                var isCurrentPage = router_default().asPath.includes("/group-chat/".concat(chatId));
                var isEventMessage = (newMessage === null || newMessage === void 0 ? void 0 : newMessage.body_type) === constant/* MESSAGE_BODY_TYPE.MESSAGE_BODY_TYPE_EVENT */.dn.MESSAGE_BODY_TYPE_EVENT;
                var isNotLeaveEvent = ((newMessage === null || newMessage === void 0 ? void 0 : (ref21 = newMessage.body) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.event) === null || ref22 === void 0 ? void 0 : ref22.text) || "").toLowerCase() !== "you left";
                if (isCurrentPage && isEventMessage && isNotLeaveEvent) {
                    handleRefreshGroupRoom(chatId);
                }
            } else {
                // update message if id has available on convo,
                updateMessageFromWS({
                    chatId: newRoom.id,
                    messageId: newMessage.id,
                    message: newMessage
                });
            }
        }
    };
    var actionRoomList = function(incomingChat) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var body = incomingChat.body;
        var newRoom = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatRoomInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.room;
        newRoom = (0,utils/* snakelizeKeys */.t_)(newRoom);
        var messageId = newRoom === null || newRoom === void 0 ? void 0 : (ref4 = newRoom.last_message) === null || ref4 === void 0 ? void 0 : ref4.id;
        var isAccepted = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.state) === constant/* StateChatList.ROOM_STATE_ACCEPTED */.Kn.ROOM_STATE_ACCEPTED;
        var isPersonalChat = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) === constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL;
        var isBroadcast = // TODO: remove 3
        // While waiting for proto definition encoding is done,
        // we use number 3 as broadcast type,
        // Currently, BE is sending 3 instead of ROOM_TYPE_BROADCAST
        (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) === constant/* RoomTypeFromPayload.BROADCAST */._2.BROADCAST;
        var roomList = isAccepted ? defaultRooms : invitedRooms;
        var lastMessage = (0,immer_esm/* default */.ZP)(newRoom === null || newRoom === void 0 ? void 0 : newRoom.last_message, function(draft) {
            var ref, ref1, ref2, ref3;
            draft.text = (newRoom === null || newRoom === void 0 ? void 0 : (ref = newRoom.last_message) === null || ref === void 0 ? void 0 : ref.text) ? newRoom.last_message.text : "";
            draft.sender_username = ((ref1 = newRoom.last_message) === null || ref1 === void 0 ? void 0 : ref1.sender_username) || "";
            // Replace last message if user delete their own latest chat
            if ((newRoom === null || newRoom === void 0 ? void 0 : (ref2 = newRoom.last_message) === null || ref2 === void 0 ? void 0 : ref2.text) === "This message was deleted" && ((ref3 = newRoom.last_message) === null || ref3 === void 0 ? void 0 : ref3.sender_username) === dataLoggedInUser.username) {
                draft.text = "You deleted this message";
                draft.placeholder_mask.masked_text = "You deleted this message";
            }
        });
        // ws social not send sender userId
        var senderUserName = lastMessage.sender_username;
        var isReceiver = senderUserName !== dataLoggedInUser.username;
        var isEventMessage = isPersonalChat || isBroadcast ? false : !senderUserName;
        var roomIdx = roomList.findIndex(function(item) {
            return item.id === (newRoom === null || newRoom === void 0 ? void 0 : newRoom.id);
        });
        var isDuplicated = messages ? checkMessageDuplicated(messages, newRoom === null || newRoom === void 0 ? void 0 : newRoom.id, newRoom === null || newRoom === void 0 ? void 0 : (ref5 = newRoom.last_message) === null || ref5 === void 0 ? void 0 : ref5.id) : false;
        // existing chatroom
        if (roomIdx > -1) {
            var ref8, ref9, ref10;
            var roomInfo = isPersonalChat || isBroadcast ? roomList[roomIdx].info : (0,_object_spread/* default */.Z)({
                avatar_url: (newRoom === null || newRoom === void 0 ? void 0 : (ref8 = newRoom.info) === null || ref8 === void 0 ? void 0 : ref8.avatar_url) || ""
            }, newRoom === null || newRoom === void 0 ? void 0 : newRoom.info);
            var updateLastMessage = isDuplicated ? ((ref10 = (ref9 = messages[newRoom === null || newRoom === void 0 ? void 0 : newRoom.id]) === null || ref9 === void 0 ? void 0 : ref9.messages[0]) === null || ref10 === void 0 ? void 0 : ref10.id) === messageId : true;
            lastMessage = updateLastMessage ? lastMessage : roomList[roomIdx].last_message;
            var unreadCount = roomList[roomIdx].unread_count || 0;
            // counter unread count chat list
            if (!isEventMessage && isReceiver && !isDuplicated) {
                unreadCount = roomList[roomIdx].unread_count + 1;
            }
            newRoom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, roomList[roomIdx]), {
                last_message: lastMessage,
                info: roomInfo,
                unread_count: unreadCount,
                status: newRoom === null || newRoom === void 0 ? void 0 : newRoom.status,
                isBroadcast: isBroadcast
            });
        } else {
            var unreadCount1 = 0;
            // counter unread count chat list
            if (!isEventMessage && isReceiver && !isDuplicated) {
                unreadCount1 += 1;
            }
            newRoom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newRoom), {
                unread_count: unreadCount1,
                isBroadcast: isBroadcast
            });
        }
        // wont update the room list if the event is us leaving
        if ((newRoom === null || newRoom === void 0 ? void 0 : (ref6 = newRoom.lastMessage) === null || ref6 === void 0 ? void 0 : ref6.text) !== "You left") {
            updateRoomListFromWS(newRoom);
        }
        // Show Left Bottom Push Notification
        var isInvitedChat = newRoom.state === constant/* StateChatList.ROOM_STATE_INVITED */.Kn.ROOM_STATE_INVITED;
        var isMuted = newRoom.status.isMuted || false;
        var getCurrentIncomingNotifType = (ref7 = (0,utils/* getNotifType */.K5)(newRoom)) === null || ref7 === void 0 ? void 0 : ref7.notifType;
        var incomingMessageDataNotifSetting = notif.find(function(notifGroup) {
            return notifGroup.group === constant/* NOTIF_GROUP_CHAT */.wS;
        }).notifications.find(function(notifItem) {
            return notifItem.type === getCurrentIncomingNotifType;
        });
        if (isReceiver && !isMuted && incomingMessageDataNotifSetting) {
            var isDesktopNotificationTurnOn = incomingMessageDataNotifSetting.settings.find(function(setting) {
                return setting.key === constant/* NOTIF_SETTING_KEY_DN */.gK;
            }).value;
            if (isDesktopNotificationTurnOn) {
                var ref11, ref12, ref13, ref14, ref15, ref16;
                var groupChatName = (newRoom === null || newRoom === void 0 ? void 0 : (ref11 = newRoom.info) === null || ref11 === void 0 ? void 0 : ref11.name) || "Group Chat";
                var usernameAtGroup = senderUserName ? "".concat(senderUserName, " @") : "";
                var notifTitle = newRoom.type === constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL ? senderUserName : "".concat(usernameAtGroup, " ").concat(groupChatName);
                var lastMessageType = (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) || constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED;
                (0,Notification/* showChatNotification */.Ac)({
                    title: notifTitle,
                    description: transformToNotifMessage(lastMessage.text, lastMessageType),
                    isDeactivate: (newRoom === null || newRoom === void 0 ? void 0 : (ref12 = newRoom.attributes) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.personal) === null || ref13 === void 0 ? void 0 : ref13.is_deactivated) || false,
                    name: (newRoom === null || newRoom === void 0 ? void 0 : (ref14 = newRoom.info) === null || ref14 === void 0 ? void 0 : ref14.name) || "",
                    shortName: (newRoom === null || newRoom === void 0 ? void 0 : (ref15 = newRoom.info) === null || ref15 === void 0 ? void 0 : ref15.shortened_name) || "",
                    type: (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) || constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL,
                    avatar: (newRoom === null || newRoom === void 0 ? void 0 : (ref16 = newRoom.info) === null || ref16 === void 0 ? void 0 : ref16.avatar_url) || "",
                    id: (newRoom === null || newRoom === void 0 ? void 0 : newRoom.id) || 0,
                    key: "in-app-notification-".concat(newRoom === null || newRoom === void 0 ? void 0 : newRoom.id),
                    isPersonalChat: isPersonalChat,
                    isInvitedChat: isInvitedChat,
                    onClose: function() {
                        dispatch(WebSocketV2_slice/* default.actions.clearChat */.ZP.actions.clearChat());
                    }
                });
            }
        }
    };
    var _obj;
    var actionEventType = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* EVENT_TYPE_BROADCAST.TYPE_CHAT_MESSAGE */.aw.TYPE_CHAT_MESSAGE, function(incomingChat) {
        return actionChatRoom(incomingChat);
    }), (0,_define_property/* default */.Z)(_obj, constant/* EVENT_TYPE_BROADCAST.TYPE_CHAT_ROOM_INFO */.aw.TYPE_CHAT_ROOM_INFO, function(incomingChat) {
        return actionRoomList(incomingChat);
    }), _obj);
    var actionTypeBroadCast = function(incomingChat) {
        var ref, ref1;
        var incomingBodyEventType = incomingChat === null || incomingChat === void 0 ? void 0 : (ref = incomingChat.body) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.type;
        return actionEventType[incomingBodyEventType] && actionEventType[incomingBodyEventType](incomingChat);
    };
    var chatListener = function(incomingChat) {
        if (incomingChat) {
            /* Additional information

        1. SEND MESSAGE
        When user send message to group room or personal room,
        ws will send event new messages as a sender so after
        that, we will update the slice conversations.

        2. OLD WEBSOCKET
        There is 3 version of WS, the old (M) that have been
        deprecated, the new (M2) and the latest one (M3).
        In this listener we will only use M3 as our WS event.
        To prevent doubled event sented to us, we use message.id
        as identifier to check if the message has been save in
        redux/slice or not.

        3. BODY TYPE OF EVENT
        Personal room and group room message now have same
        body payload. We dont need to transform the body.

       */ actionTypeBroadCast(incomingChat);
        }
    };
    (0,react.useEffect)(function() {
        if (!isUserLogin) {
            return;
        }
        // After check the behaviour, it more safe to use
        // synchronously process instead of asynchronous
        // when receive double events from ws
        // @ts-ignore
        chatListener(newIncomingChatWsSocialV2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newIncomingChatWsSocialV2,
        isUserLogin
    ]);
    return null;
}
/* harmony default export */ var hooks_useChatListenerWsSocialV2 = (useChatListenerWsSocialV2);

// EXTERNAL MODULE: ./src/features/community/hooks/useGetReferralInfo.ts
var useGetReferralInfo = __webpack_require__(37220);
// EXTERNAL MODULE: ./src/stores/chat/useGetChatUnreadCount.ts
var useGetChatUnreadCount = __webpack_require__(9986);
// EXTERNAL MODULE: ./src/features/transaction/provider.tsx + 1 modules
var provider = __webpack_require__(207);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/MainLayout/styled.ts
var styled = __webpack_require__(92589);
// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
;// CONCATENATED MODULE: ./src/global/MainLayout/__tests__/constant.ts
var DATA_CY_MAIN_LAYOUT = "main-layout";

;// CONCATENATED MODULE: ./src/global/MainLayout/index.tsx
/* eslint-disable react/forbid-prop-types */ 










// Local Components








// import webSocketSlice from 'global/WebSocketV2/slice';

// local redux slice


var HeaderWeb = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2678), __webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(92077), __webpack_require__.e(42298), __webpack_require__.e(70659), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(63923), __webpack_require__.e(77934), __webpack_require__.e(50011), __webpack_require__.e(73671)]).then(__webpack_require__.bind(__webpack_require__, 73671));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73671)
            ];
        }
    },
    ssr: false
});
var HeaderMobile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2678), __webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(42298), __webpack_require__.e(70659), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(63923), __webpack_require__.e(77934), __webpack_require__.e(12127)]).then(__webpack_require__.bind(__webpack_require__, 12127));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12127)
            ];
        }
    },
    ssr: false
});
var SideWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(79931), __webpack_require__.e(35851), __webpack_require__.e(46312), __webpack_require__.e(74749), __webpack_require__.e(6581), __webpack_require__.e(57437)]).then(__webpack_require__.bind(__webpack_require__, 69908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69908)
            ];
        }
    },
    ssr: false
});
var OnBoarding = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(29306), __webpack_require__.e(7475), __webpack_require__.e(54392), __webpack_require__.e(24826), __webpack_require__.e(91086)]).then(__webpack_require__.bind(__webpack_require__, 91086));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91086)
            ];
        }
    },
    ssr: false
});
var ModalTransactionSecurities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(60296), __webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(79931), __webpack_require__.e(42298), __webpack_require__.e(35851), __webpack_require__.e(36055), __webpack_require__.e(67555), __webpack_require__.e(97751), __webpack_require__.e(80822), __webpack_require__.e(98294), __webpack_require__.e(76219), __webpack_require__.e(48761), __webpack_require__.e(54392), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(36902), __webpack_require__.e(48308), __webpack_require__.e(79624), __webpack_require__.e(91727), __webpack_require__.e(6684), __webpack_require__.e(10231), __webpack_require__.e(70536), __webpack_require__.e(12104), __webpack_require__.e(37376), __webpack_require__.e(18027), __webpack_require__.e(5411)]).then(__webpack_require__.bind(__webpack_require__, 39337));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39337)
            ];
        }
    },
    ssr: false
});
var ModalAuthSecurities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(42298), __webpack_require__.e(61980), __webpack_require__.e(75413), __webpack_require__.e(36902), __webpack_require__.e(38305), __webpack_require__.e(62366), __webpack_require__.e(49432)]).then(__webpack_require__.bind(__webpack_require__, 62366));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62366)
            ];
        }
    },
    ssr: false
});
var ModalShareTradeManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(79931), __webpack_require__.e(42298), __webpack_require__.e(35851), __webpack_require__.e(36055), __webpack_require__.e(33082), __webpack_require__.e(67555), __webpack_require__.e(97751), __webpack_require__.e(98294), __webpack_require__.e(76219), __webpack_require__.e(75413), __webpack_require__.e(36902), __webpack_require__.e(48308), __webpack_require__.e(68106), __webpack_require__.e(20242), __webpack_require__.e(83474), __webpack_require__.e(65972)]).then(__webpack_require__.bind(__webpack_require__, 61785));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61785)
            ];
        }
    },
    ssr: false
});
var GlobalModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(79931), __webpack_require__.e(42298), __webpack_require__.e(35851), __webpack_require__.e(33082), __webpack_require__.e(80822), __webpack_require__.e(1013), __webpack_require__.e(75413), __webpack_require__.e(74673), __webpack_require__.e(36902), __webpack_require__.e(10231), __webpack_require__.e(61442), __webpack_require__.e(88115), __webpack_require__.e(59795), __webpack_require__.e(21764)]).then(__webpack_require__.bind(__webpack_require__, 9159));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9159)
            ];
        }
    },
    ssr: false
});
var ModalBonds = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(80822), __webpack_require__.e(61980), __webpack_require__.e(98294), __webpack_require__.e(48761), __webpack_require__.e(36385), __webpack_require__.e(69733), __webpack_require__.e(54392), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(91727), __webpack_require__.e(29184), __webpack_require__.e(70536), __webpack_require__.e(33516)]).then(__webpack_require__.bind(__webpack_require__, 14426));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14426)
            ];
        }
    },
    ssr: false
});
var ModalUnavailable = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(12438)]).then(__webpack_require__.bind(__webpack_require__, 15994));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15994)
            ];
        }
    },
    ssr: false
});
var ModalErrorManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(92093)]).then(__webpack_require__.bind(__webpack_require__, 51906));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51906)
            ];
        }
    },
    ssr: false
});
var MultiPortoModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(92077), __webpack_require__.e(42298), __webpack_require__.e(98294), __webpack_require__.e(68606), __webpack_require__.e(44975)]).then(__webpack_require__.bind(__webpack_require__, 44975));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44975)
            ];
        }
    },
    ssr: false
});
var StreamErrorModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(61980), __webpack_require__.e(5633), __webpack_require__.e(38305), __webpack_require__.e(40728), __webpack_require__.e(29901)]).then(__webpack_require__.bind(__webpack_require__, 91011));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91011)
            ];
        }
    },
    ssr: false
});
var DatafeedModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(66158)]).then(__webpack_require__.bind(__webpack_require__, 44992));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44992)
            ];
        }
    },
    ssr: false
});
function MainLayout(param) {
    var children = param.children, isFlexibleWidth = param.isFlexibleWidth, maxWidth = param.maxWidth, background = param.background, width = param.width, _fullPage = param.fullPage, fullPage = _fullPage === void 0 ? false : _fullPage;
    // Library hooks
    var dispatch = (0,es/* useDispatch */.I0)();
    var breakpoints = (0,useBreakpoint/* default */.Z)();
    // Zustand store
    var ref = (0,useGetChatUnreadCount/* useGetChatUnreadCount */.H)(function(s) {
        return {
            fetchChatUnreadCount: s.fetchUnreadCount,
            isChatUnreadCountReset: s.isReset
        };
    }), fetchChatUnreadCount = ref.fetchChatUnreadCount, isChatUnreadCountReset = ref.isChatUnreadCountReset;
    var fetchCommunityInfo = (0,useGetReferralInfo/* useGetReferralInfo */.s)(function(s) {
        return s.fetchCommunityInfo;
    });
    // Redux store
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var ref1 = (0,es/* useSelector */.v9)(MainLayout_slice/* selectors */.wl), isSideWidgetOpen = ref1.isSideWidgetOpen, isHeaderMinimized = ref1.isHeaderMinimized, isMarketOpen = ref1.isMarketOpen;
    // Custom hooks
    var onboardingProgress = hooks_useOnBoarding().onboardingProgress;
    (0,useProfileData/* default */.Z)();
    (0,useNotificationListener/* default */.Z)(isLoggedIn);
    hooks_useChatListenerWsSocialV2(isLoggedIn);
    // Reactive variable
    var isShowOnboarding = onboardingProgress < constants/* ONBOARDING_MAX_STEP */.Rm;
    var props = width ? {
        style: {
            width: width
        }
    } : {};
    (0,react.useEffect)(function() {
        if (!isLoggedIn) {
            return;
        }
        // During route changes or reload:
        // re-fetch unread chat if state is haven't reset
        // or clear chat data if state have reset
        // if (!isChatUnreadCountReset) {
        //   fetchChatUnreadCount();
        // } else {
        //   dispatch(webSocketSlice.actions.clearChat());
        // }
        fetchChatUnreadCount();
        fetchCommunityInfo();
        dispatch(slice/* effects.getNotifications */.Sz.getNotifications());
    }, [
        isLoggedIn
    ]);
    // React render
    if (isShowOnboarding) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoarding, {
            progress: onboardingProgress
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-cy": DATA_CY_MAIN_LAYOUT,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(provider/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* WrapperMainContent */.UI, {
                            isSideWidgetOpen: isSideWidgetOpen,
                            isMarketOpen: isMarketOpen,
                            children: [
                                breakpoints.md ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWeb, {
                                    isSideWidgetOpen: isSideWidgetOpen,
                                    isMarketOpen: isMarketOpen,
                                    isHeaderMinimized: isHeaderMinimized
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobile, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Wrapper */.im, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    background: background,
                                    isSideWidgetOpen: isSideWidgetOpen
                                }, props), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* default */.ZP, {
                                        id: "main-container",
                                        isFlexibleWidth: isFlexibleWidth,
                                        maxWidth: maxWidth,
                                        isSideWidgetOpen: isSideWidgetOpen,
                                        fullPage: fullPage,
                                        isMarketOpen: isMarketOpen,
                                        children: children
                                    })
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAuthSecurities, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTransactionSecurities, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTradeManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUnavailable, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiPortoModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamErrorModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedModalManager, {})
            ]
        })
    });
}
MainLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    isFlexibleWidth: (prop_types_default()).bool,
    maxWidth: (prop_types_default()).number,
    background: (prop_types_default()).string,
    width: (prop_types_default()).any
};
MainLayout.defaultProps = {
    isFlexibleWidth: false,
    maxWidth: undefined,
    background: "transparent",
    width: undefined
};
/* harmony default export */ var global_MainLayout = (MainLayout);


/***/ }),

/***/ 92589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RU": function() { return /* binding */ SIDE_WIDGET_OPENED_WIDTH; },
/* harmony export */   "U9": function() { return /* binding */ SIDE_WIDGET_CONTENT_WIDTH; },
/* harmony export */   "UI": function() { return /* binding */ WrapperMainContent; },
/* harmony export */   "Uh": function() { return /* binding */ device; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "zX": function() { return /* binding */ SIDE_WIDGET_TOOLBAR_WIDTH; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74575);
/* eslint-disable space-infix-ops */ /* eslint-disable indent */ /* eslint-disable no-confusing-arrow */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      @media ",
        " {\n        width: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 40px auto 0 auto;\n  padding: ",
        ";\n  width: 100%;\n  max-width: ",
        ";\n\n  &.chat-expanded {\n    margin: 0 auto 0 auto !important;\n    padding: 0 !important;\n  }\n\n  ",
        "\n\n  @media ",
        " {\n    margin: 100px auto 0;\n    max-width: ",
        ";\n\n    &.chat-expanded {\n      margin: 0px auto 0 auto !important;\n      padding: 20px 37px 0 0 !important;\n    }\n  }\n\n  @media ",
        " {\n    max-width: ",
        ";\n    &:has(#academy-iframe) {\n      position: absolute !important;\n      left: 0;\n      padding-bottom: 0;\n      width: 100% !important;\n      max-width: ",
        ";\n      margin: ",
        ";\n    }\n  }\n\n  @media screen and (min-width: 1500px) {\n    margin: 100px auto 0 auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


// TODO: Update device dimension to DS
var laptopM = "(min-width:1081px)";
var device = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    laptopM: laptopM
});
var SIDE_WIDGET_CONTENT_WIDTH = "330px";
var SIDE_WIDGET_TOOLBAR_WIDTH = "35px";
var SIDE_WIDGET_OPENED_WIDTH = "365px";
// prettier-ignore
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].main.withConfig */ .ZP.main.withConfig({
    componentId: "sc-98894054-0"
})(_templateObject1(), function(props) {
    return props.fullPage ? "0" : "20px 0";
}, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "990px";
}, function(props) {
    return props.isFlexibleWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), device.tablet, props.isMarketOpen ? "calc(100% - 60px)" : "calc(100% - 100px)");
}, device.tablet, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "660px";
}, device.laptopM, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "990px";
}, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isMarketOpen = param.isMarketOpen;
    return function() {
        if (!isSideWidgetOpen) {
            return "unset";
        }
        if (!isMarketOpen) {
            return "calc(100% - 425px) !important";
        }
        return "calc(100% - 365px) !important";
    }();
}, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen;
    return isSideWidgetOpen && "auto !important";
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-98894054-1"
})(_templateObject2(), function(props) {
    return props.background ? props.background : "transparent";
});
var WrapperMainContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-98894054-2"
})(_templateObject3(), function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isMarketOpen = param.isMarketOpen;
    return function() {
        if (!isSideWidgetOpen) {
            return "calc(100% - ".concat(SIDE_WIDGET_TOOLBAR_WIDTH, ") ");
        }
        if (!isMarketOpen) {
            return "calc(100% - 425px)";
        }
        return "calc(100% - 365px)";
    }();
});
/* harmony default export */ __webpack_exports__["ZP"] = (Container);


/***/ }),

/***/ 89561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "By": function() { return /* binding */ deleteReferral; },
/* harmony export */   "ER": function() { return /* binding */ getReferralStatus; },
/* harmony export */   "H5": function() { return /* binding */ postApplyReferral; },
/* harmony export */   "KT": function() { return /* binding */ getReferralByCode; },
/* harmony export */   "Qu": function() { return /* binding */ getReferralInfo; },
/* harmony export */   "ve": function() { return /* binding */ getReferralMembers; }
/* harmony export */ });
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var request = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestWithoutAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
var getReferralInfo = function() {
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/info"));
};
var getReferralStatus = function() {
    return requestWithoutAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/status"));
};
var getReferralByCode = function(code) {
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/").concat(code));
};
var getReferralMembers = function(param) {
    var keyword = param.keyword, status = param.status, startDate = param.startDate, endDate = param.endDate, cursor = param.cursor;
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/affiliate/members"), {
        params: {
            search: keyword !== "" ? keyword : undefined,
            status: status !== "MEMBER_STATUS_UNSPECIFIED" ? status : undefined,
            start_date: startDate,
            end_date: endDate,
            cursor: cursor
        }
    });
};
var postApplyReferral = function(code) {
    return request.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/apply"), {
        code: code
    });
};
var deleteReferral = function() {
    return request.delete("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral"));
};
var communityAPI = {
    getReferralInfo: getReferralInfo,
    getReferralStatus: getReferralStatus,
    getReferralByCode: getReferralByCode,
    getReferralMembers: getReferralMembers,
    postApplyReferral: postApplyReferral,
    deleteReferral: deleteReferral
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (communityAPI)));


/***/ })

}]);